export const ENDPOINTS = {
  projects: 'v1/search-projects',
}